import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import { connect } from 'react-redux'
import Toggle from 'material-ui/Toggle'

import ModulesUtils from 'infra/ModulesUtils'

class MaterialItem extends React.Component {

  static propTypes = {
    index: PropTypes.number.isRequired,
    expanded: PropTypes.bool,
    material: PropTypes.shape().isRequired,
    teamMembers: PropTypes.array.isRequired,
    onPress: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      material: props.material
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ material: nextProps.material })
  }

  constructDate(date){
    return moment(date).format('MM/DD/YYYY')
  }

  getMaterialCost = material => {
    const quantity = material.quantity ? parseFloat(material.quantity.trim()) : 0
    const cost = material.cost ? parseFloat(material.cost.trim()) : 0
    if (!isNaN(quantity) && !isNaN(cost)) {
      return quantity * cost
    }
    return null
  }

  render() {
    const workerName = ModulesUtils.getMemberName(this.props.teamMembers, this.state.material.userId)
    const name = this.state.material.name ? this.state.material.name.trim() : ''
    const store = this.state.material.store ? this.state.material.store.trim() : ''
    const quantity = this.state.material.quantity ? this.state.material.quantity.trim() : ''
    const units = this.state.material.units ? this.state.material.units.trim() : ''
    const cost = this.state.material.cost ? ('$' + this.state.material.cost.trim()) : ''
    const totalCost =  this.getMaterialCost(this.state.material)
    const totalCostStr = totalCost && totalCost > 0 ? `$${totalCost.toFixed(2)}` : ''
    const usedOn = this.state.material.jobDateStr ? this.constructDate(this.state.material.jobDateStr): ''
    const addedBy = workerName ? workerName : ''
    const notes = this.state.material.notes ? this.state.material.notes.trim() : ''
    const reimbursed = this.state.material.reimbursed ? this.state.material.reimbursed : false
    const billable = this.state.material.billable ? this.state.material.billable : false

    const { expanded } = this.props

    const selectIcon = expanded ? '--' : '+'
    return (
      <div>
        <div style={{ ...styles.listRowContainer, ...styles.row(this.props.index, expanded) }} onClick={this.props.onPress}>
          <div style={{ ...styles.selectIcon, ...styles.listSelectWidth }}>{ selectIcon }</div>
          <div style={{ ...styles.listRowColumn, ...styles.listMainWidth }}>{ name }</div>
          <div style={{ ...styles.listRowColumn, ...styles.listMinorWidth }}> { quantity } { units }</div>
          <div style={{ ...styles.listRowColumn, ...styles.listMinorWidth }}> { cost }</div>
          <div style={{ ...styles.listRowColumn, ...styles.listMinorWidth }}> { totalCostStr } </div>
          <div style={{ ...styles.listRowColumn, ...styles.listMinorWidth }}> { usedOn }</div>
        </div>
        {
          this.props.expanded
          &&
          <div style={{ ...styles.cardContainer, ...styles.row(this.props.index) }}>
            <div style={styles.cardTopLine}>
              <div style={ styles.cardRow }>
                <div style={{ ...styles.cardHeader, ...styles.listMainWidth }}>
                  Store
                </div>
                <div style={styles.cardValue}>
                  { store }
                </div>
              </div>
              <div style={ styles.cardRow }>
                <div style={{ ...styles.cardHeader, ...styles.listMainWidth }}>
                  Added By
                </div>
                <div style={styles.cardValue}>
                  { addedBy }
                </div>
              </div>
              <div style={ styles.cardRow }>
                <div style={{ ...styles.cardHeader, ...styles.listMainWidth }}>
                  Notes
                </div>
                <div style={ styles.cardValue }>
                  { notes }
                </div>
              </div>
              <div style={ styles.cardRow }>
                <div style={{ ...styles.cardHeader, ...styles.listMainWidth }}>
                  Reimbursable
                </div>
                <div style={ styles.cardValue }>
                  <Toggle toggled={ reimbursed }/>
                </div>
              </div>
              <div style={ styles.cardRow }>
                <div style={{ ...styles.cardHeader, ...styles.listMainWidth }}>
                  Billable
                </div>
                <div style={ styles.cardValue }>
                  <Toggle toggled={ billable }/>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

}

const styles = {

  row: (index, expanded) => ({
    backgroundColor: index % 2 ? 'rgba(251, 235, 201, 0.30)' : 'rgba(255, 255, 255, 0.01)',
    borderBottom: 'none',
    fontWeight: expanded ? 500 : null,
    cursor: 'pointer'
  }),

  value: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    color: '#757575',
    fontSize: 14,
    paddingLeft: 14,
    paddingRight: 14,
    paddingTop: 6,
    paddingBottom: 6
  },

  multilineValue: {
    wordWrap: 'wrap',
    whiteSpace: 'normal',
    color: '#757575',
    fontSize: 14,
    paddingLeft: 14,
    paddingRight: 14,
    paddingTop: 6,
    paddingBottom: 6
  },

  listRowColumn: {
    color: '#757575',
    fontSize: 14,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8
  },

  listRowContainer: {
    display:'flex',
    flexDirection: 'row'
  },

  listMainWidth: {
    width: 200
  },

  listMinorWidth: {
    width: 100
  },

  listSelectWidth: {
    width: 16
  },

  cardContainer: {
    paddingLeft: 48,
    paddingRight: 16,
    color: '#757575',
    fontSize: 14,
    display: 'flex',
    flexDirection: 'column'
  },

  cardTopLine: {
    borderTop: '1px solid #757575',
    paddingTop: 8,
    paddingBottom: 8
  },

  cardRow: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 4,
    paddingBottom: 4
  },

  cardHeader: {
    paddingRight: 16
  },

  cardValue: {
    display: 'flex',
    paddingLeft: 16,
    width: 440,
    flexWrap: 'wrap'
  },

  selectIcon: {
    color: '#527da3',
    fontSize: 16,
    paddingLeft: 16,
    paddingTop: 8,
    paddingBottom: 8
  }

}

export default connect(state => ({ teamMembers: state.firebase.team.members.value }))(MaterialItem)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/materials/MaterialItem.js